export default "__VITE_ASSET__UHfVV3JU__"